/**
 * Represents link that opens dialog with administrator details
 *
 * @flow
 */

import React from 'react';
import styled from 'styled-components';
import withModal from '../../../lib/withModal';

import { AdministratorDetails } from './details';

import type { ModalDialogTrigger, Administrator } from '../../../type';

type AdministratorDetailsButtonProps = {
    administrator: Administrator,
    children: any,
} & ModalDialogTrigger;

const AdministratorDetailsButtonStyled = styled.span`
    cursor: pointer;
    display: flex;
    color: #000000;
    transition: color 0.3s;
    align-items: center;
    height: 44px;
    padding: 0px 11px 0px 11px;

    &:hover {
        font-weight: 600;
        color: #35a3d5;
    }
`;

const AdministratorDetailsButton = ({
    administrator,
    children,
    open,
    onOpen,
    onClose,
}: AdministratorDetailsButtonProps) => (
    <AdministratorDetails
        trigger={
            <AdministratorDetailsButtonStyled onClick={onOpen}>
                {children}
            </AdministratorDetailsButtonStyled>
        }
        administrator={administrator}
        onClose={onClose}
        open={open}
    />
);

export default withModal(AdministratorDetailsButton);
